module.exports = __webpack_public_path__ + "static/media/iconMail.bce98759.svg";